export default __webpack_public_path__ + "static/media/katika_signup.5eed178f.png";